import { EnumTipoContrato } from "../../contratos/enums/enumTipoContrato";

export enum EnumTipoEquipo {
    Ascensor = 1,
    Escalera = 2,
    Rampa = 3
}

// En contratos de Instalación (NBS) las escaleras no manejan modelo; en los demás contratos sí se solicita
export const equipoRequiereModelo = (tipoEquipoId: number, tipoContratoId: number | null) =>
    !(tipoEquipoId === EnumTipoEquipo.Escalera && tipoContratoId === EnumTipoContrato.Instalacion);
